export default __webpack_public_path__ + "static/Etiqa_logos_Full Colour-d94497bbf6244e4ea4ce9562c78d8663.png";